import { render, staticRenderFns } from "./mainTittle.vue?vue&type=template&id=a19adba2&scoped=true&"
import script from "./mainTittle.vue?vue&type=script&lang=js&"
export * from "./mainTittle.vue?vue&type=script&lang=js&"
import style0 from "./mainTittle.vue?vue&type=style&index=0&id=a19adba2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19adba2",
  null
  
)

export default component.exports